module.exports = __webpack_public_path__ + "static/media/wedding.fd7f2009.jpg";